import React, { useState, useEffect, Suspense } from 'react';
import {
  CharacterForm,
  Sidebar,
  CommunityGuidelines,
  MobileNav,
  CreatePageLoader,
  ThemeMakerModal,
  fetchCharacters,
} from '@client/components';
import { useMediaQuery, useTheme, Box } from '@mui/material';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useCharacterStore } from '@client/store';

export function CreatePage() {
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [characterUpdate, setCharacterUpdate] = useState(false);
  const [themeMakerOpen, setThemeMakerOpen] = useState(false);
  const setCharacter = useCharacterStore((state) => state.setCharacter);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { char_uuid } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const type = query.get('type') || 'character';

  useEffect(() => {
    async function init() {
      if (char_uuid && type === 'character') {
        try {
          const { characters } = await fetchCharacters({
            currentPage: 1,
            itemsPerPage: 1,
            filterCharUUID: char_uuid,
            include_sensitive: true,
          });
          const character = characters[0] ?? null;
          if (character) {
            if (character.tags && !Array.isArray(character.tags)) {
              character.tags = (character.tags as string)
                .split(',')
                .map((tag) => tag.trim());
            }
            setCharacter(character);
            setCharacterUpdate(true);
          }
        } catch (e) {
          console.error('Error loading character:', e);
        }
      }

      setIsDataLoaded(true);
    }
    init();
  }, [char_uuid, type, setCharacter]);

  useEffect(() => {
    if (type === 'theme') setThemeMakerOpen(true);
  }, [type]);

  const handleCloseThemeMaker = () => {
    setThemeMakerOpen(false);
    navigate(location.pathname + '?type=character');
  };

  if (!isDataLoaded) return <CreatePageLoader />;

  return (
    <Suspense fallback={<CreatePageLoader />}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          width: '100%',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <Sidebar />
        {isMobile && <MobileNav setShowLoginModal={() => {}} />}
        <Box
          component="main"
          sx={{
            flex: 1,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: '100%',
              overflow: 'hidden',
            }}
          >
            {type === 'character' && (
              <CharacterForm character_update={characterUpdate} />
            )}
            {type === 'theme' && (
              <ThemeMakerModal
                isOpen={themeMakerOpen}
                onClose={handleCloseThemeMaker}
              />
            )}
          </Box>
        </Box>
        <CommunityGuidelines />
      </Box>
    </Suspense>
  );
}